import { rtlLeftNormalizer } from '@s4l/utils/library/rtl'

interface IScrollToPosition {
  x?: number
  y?: number
  margin?: number
  ref?: React.RefObject<HTMLElement> | HTMLElement
}

export function getTop({ y = 0, ref, margin = 0 }: IScrollToPosition): number {
  const element = ref && 'current' in ref ? ref.current : ref
  if (!element || !element.getBoundingClientRect) return y
  const scrollTop = window?.scrollY || document.documentElement.scrollTop
  return element.getBoundingClientRect().top + scrollTop + margin
}

export function scrollToPosition({ x = 0, y = 0, ref, margin = 0 }: IScrollToPosition = {}) {
  if (typeof window === 'undefined') {
    return null
  }

  const left = rtlLeftNormalizer(x)
  const top = getTop({ y, ref, margin })

  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({ left, top, behavior: 'smooth' })
  } else {
    window.scrollTo(left, top)
  }
  return null
}
